/* AfterShed v3 shared behaviour. Loaded with defer from layout/theme.liquid and the lean layouts.
   - R3.ctx: the visitor's situation for this tab only (sessionStorage 'r3_ctx', 2 hours). Never in URLs.
   - Tracking passthrough: the agreed ad parameters ride along on internal links, minus any value that
     names a health topic. Situation codes, quiz answers and phases are never added to links.
   - Small UI behaviours used by several r3 sections: tabs, situation links, sticky buy bar. */
(function () {
  'use strict';

  var CTX_KEY = 'r3_ctx';
  var TRACK_KEY = 'r3_track';
  var TTL = 2 * 60 * 60 * 1000;
  var SITS = ['menopause', 'postpartum', 'weight', 'stress', 'pill', 'unsure'];
  var TRACK_PARAMS = /^(utm_(source|medium|campaign|id|term|content)|tw_(source|adid)|fbclid|gclid|ttclid|ad_id)$/;
  var HEALTH = /glp|ozemp|wegovy|mounjaro|zepbound|saxenda|rybelsus|semaglut|sema\b|tirzepat|tirz|liraglut|menopaus|perimeno|\bmeno|\bperi\b|postpart|postnatal|pregnan|newborn|new.?mom|baby|breast.?feed|nursing|birth.?control|contracept|fertil|ttc|off.?the.?pill|(^|[^a-z])(pill|hrt|ivf|pcos)([^a-z]|$)|hormon|estrogen|thyroid|weight.?loss|weightloss|diet|illness|covid|stress|hair.?loss|hairloss|alopecia|minoxidil|shedding|thinning/i;

  function readJSON(store, key) {
    try { return JSON.parse(store.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function writeJSON(store, key, value) {
    try { store.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  var R3 = (window.R3 = window.R3 || {});

  R3.ctx = {
    get: function () {
      var c = readJSON(sessionStorage, CTX_KEY);
      if (!c || typeof c !== 'object' || !c.at || Date.now() - c.at > TTL) return {};
      return c;
    },
    set: function (patch) {
      var c = R3.ctx.get();
      for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) c[k] = patch[k];
      c.at = Date.now();
      writeJSON(sessionStorage, CTX_KEY, c);
      return c;
    },
    clear: function () {
      try { sessionStorage.removeItem(CTX_KEY); } catch (e) {}
    }
  };

  /* Tracking parameters: capture on landing, keep for this tab, add to internal links. */
  function captureTracking() {
    var params = new URLSearchParams(window.location.search);
    var found = {};
    params.forEach(function (value, key) {
      var k = key.toLowerCase();
      if (TRACK_PARAMS.test(k) && value && !HEALTH.test(value)) found[k] = value;
    });
    if (Object.keys(found).length) writeJSON(sessionStorage, TRACK_KEY, { p: found, at: Date.now() });
    var stored = readJSON(sessionStorage, TRACK_KEY);
    if (!stored || !stored.p || Date.now() - stored.at > TTL) return {};
    return stored.p;
  }

  function isInternal(u) {
    return u.origin === window.location.origin && /^\/(products|pages|collections|cart)(\/|$)/.test(u.pathname);
  }

  function decorate(a, track) {
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
    var u;
    try { u = new URL(href, window.location.href); } catch (e) { return; }
    if (!isInternal(u)) return;
    var changed = false;
    ['c', 'cause', 'trigger', 'phase'].forEach(function (k) {
      if (u.searchParams.has(k)) { u.searchParams.delete(k); changed = true; }
    });
    Object.keys(track).forEach(function (k) {
      if (!u.searchParams.has(k)) { u.searchParams.set(k, track[k]); changed = true; }
    });
    if (changed) a.setAttribute('href', u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '') + u.hash);
  }

  R3.decorateLinks = function (root) {
    var track = captureTracking();
    (root || document).querySelectorAll('a[href]').forEach(function (a) { decorate(a, track); });
  };

  /* Links that carry a situation: <a href="/pages/quiz" data-r3-sit="menopause"> */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-r3-sit]');
    if (!a) return;
    var sit = a.getAttribute('data-r3-sit');
    if (SITS.indexOf(sit) === -1) return;
    R3.ctx.set({ sit: sit, src: a.getAttribute('data-r3-src') || 'link' });
  }, true);

  /* Tabs: [data-r3-tabs] container with [role=tab] buttons and [role=tabpanel] panels. */
  R3.initTabs = function (root) {
    (root || document).querySelectorAll('[data-r3-tabs]:not([data-r3-ready])').forEach(function (box) {
      box.setAttribute('data-r3-ready', '');
      var tabs = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
      function select(tab, focus, user) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        box.querySelectorAll('[data-r3-tab-media]').forEach(function (m) {
          m.classList.toggle('is-active', m.getAttribute('data-r3-tab-media') === tab.id);
        });
        if (focus) tab.focus();
        var strip = box.querySelector('.r3-tabs');
        if (user && strip && strip.scrollWidth > strip.clientWidth) {
          var tl = tab.offsetLeft - strip.offsetLeft;
          strip.scrollTo({ left: Math.max(0, tl - 16), behavior: 'smooth' });
        }
      }
      var initial = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
      if (initial) select(initial, false, false);
      box.classList.add('is-enhanced');
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false, true); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') next = tabs[0];
          if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true, true); }
        });
      });
    });
  };

  /* Sticky bar: [data-r3-sticky] becomes visible when [data-r3-sticky-watch] is out of view
     and hides again while any [data-r3-sticky-hide] element is on screen. */
  R3.initSticky = function () {
    var bar = document.querySelector('[data-r3-sticky]');
    var watch = document.querySelector('[data-r3-sticky-watch]');
    if (!bar || !watch || !('IntersectionObserver' in window)) return;
    var watchVisible = true;
    var hiders = new Set();
    function update() {
      var show = !watchVisible && hiders.size === 0 && watch.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { watchVisible = en.isIntersecting; });
      update();
    }).observe(watch);
    var hideObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) hiders.add(en.target); else hiders.delete(en.target); });
      update();
    });
    document.querySelectorAll('[data-r3-sticky-hide]').forEach(function (el) { hideObs.observe(el); });
    update();
  };

  /* Situation-specific content: [data-r3-show-sit="menopause"] is shown only to visitors with that context. */
  R3.applySit = function (root) {
    var sit = R3.ctx.get().sit;
    (root || document).querySelectorAll('[data-r3-show-sit]').forEach(function (el) {
      el.hidden = el.getAttribute('data-r3-show-sit') !== sit;
    });
  };

  function boot() {
    R3.applySit(document);
    R3.decorateLinks(document);
    R3.initTabs(document);
    R3.initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { R3.decorateLinks(e.target); R3.initTabs(e.target); });
})();
